import React from 'react';
import { UtilitiesProvider } from '@warehouse/quickbase';
import { UtilitiesQuickbase } from './Utilities';

export function Utilities() {
	return (
		<UtilitiesProvider>
			<UtilitiesQuickbase />
		</UtilitiesProvider>
	);
}
